import type { StateCreator } from 'zustand';

import type { AITransfersStore } from './useAITransfersStore';
import type { SolverProfile } from '@api-service/recommendations';

export type SolverConfiguration = SolverProfile['configuration'];

/** Sentinel profile id for a member-tuned configuration. */
export const CUSTOM_PROFILE_ID = 'custom';

/**
 * The member's manager profile choice. Mirrors the mobile app's preferences
 * slice: a backend profile name, or CUSTOM_PROFILE_ID with a tuned
 * configuration; null means the backend's default profile.
 */
export interface PreferencesSlice {
  selectedProfileId: string | null;
  customConfiguration: SolverConfiguration | null;
  setPreferences: (
    profileId: string,
    configuration: SolverConfiguration | null
  ) => void;
}

export const createPreferencesSlice: StateCreator<
  AITransfersStore,
  [],
  [],
  PreferencesSlice
> = (set) => ({
  selectedProfileId: null,
  customConfiguration: null,
  setPreferences: (profileId, configuration) =>
    set({
      selectedProfileId: profileId,
      customConfiguration:
        profileId === CUSTOM_PROFILE_ID ? configuration : null
    })
});
